"use strict";
'use es6'; // For specific documentation on the Sanitize.js library, config, or transformers, see: https://github.com/gbirke/Sanitize.js

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = exports.secureDocument = void 0;

var _sanitize = _interopRequireDefault(require("sanitize"));

// createHTMLDocument MUST be passed a title or else sanitized content will break in Internet Explorer: https://issues.hubspotcentral.com/browse/CRM-17134
var secureDocument = document.implementation.createHTMLDocument('sanitize');
exports.secureDocument = secureDocument;
var config = {
  HTML: {
    elements: ['a', 'b', 'blockquote', 'br', 'caption', 'cite', 'code', 'col', 'colgroup', 'dd', 'dl', 'dt', 'em', 'figure', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'i', 'img', 'li', 'ol', 'p', 'pre', 'q', 'small', 'strike', 'strong', 'sub', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'u', 'ul', 'font', 'div', 'span'],
    dom: secureDocument,
    attributes: {
      __ALL__: ['style', 'align', 'valign', 'color', 'width', 'height'],
      a: ['href', 'title', 'target'],
      blockquote: ['cite'],
      col: ['span'],
      colgroup: ['span'],
      img: ['alt', 'data-original-height', 'data-original-width', 'src', 'title'],
      ol: ['start', 'type'],
      q: ['cite'],
      table: ['summary', 'bgcolor', 'cellpadding', 'cellspacing'],
      td: ['abbr', 'axis', 'colspan', 'rowspan'],
      th: ['abbr', 'axis', 'colspan', 'rowspan', 'scope'],
      ul: ['type'],
      font: ['size', 'face'],
      span: ['data-at-mention', 'data-owner-id', 'contenteditable', 'data-email-reply']
    },
    add_attributes: {
      a: {
        rel: 'nofollow noopener noreferrer'
      }
    },
    protocols: {
      a: {
        href: ['ftp', 'http', 'https', 'mailto', 'tel', 'mms', 'sms', _sanitize.default.RELATIVE]
      },
      blockquote: {
        cite: ['http', 'https', _sanitize.default.RELATIVE]
      },
      img: {
        src: ['data', 'http', 'https', _sanitize.default.RELATIVE]
      },
      q: {
        cite: ['http', 'https', _sanitize.default.RELATIVE]
      }
    },
    remove_contents: ['script', 'style']
  },
  TEXTONLY: {
    dom: secureDocument,
    elements: [],
    remove_contents: ['style', 'script']
  }
};
exports.config = config;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/sanitize-text/static-1.1206/js/sanitizers/SanitizeConfiguration.js
// module id = 110
// module chunks = 209 210 211 212